import { button } from '../../../../../component/component'

export default function(o,c){

  var stop =
    button(null,'fi-stop')
    .click(function(){
      o.video.pause()
      o.playing = false
      o.loopStart = o.video.currentTime
      c.stop.hide()
      c.play.show()
    })

  return stop

}



// WEBPACK FOOTER //
// ./src/client/view/admin/controls/buttons/stop/stop.js